/**
 * Shared config. Every exported value can be supplied from environment variables.
 * Browser-visible values must also use REACT_APP_* because Create React App only
 * inlines those names into the client bundle.
 */

function firstEnv(keys, fallback = "") {
  for (const key of keys) {
    const value = process.env[key];
    if (value != null && String(value).trim() !== "") return String(value);
  }
  return fallback;
}

function envNumber(keys, fallback) {
  const value = Number(firstEnv(keys, fallback));
  return Number.isFinite(value) ? value : fallback;
}

function envBoolean(keys, fallback) {
  const value = firstEnv(keys, "");
  if (value === "") return fallback;
  return ["1", "true", "yes", "on"].includes(String(value).trim().toLowerCase());
}

const PORT = envNumber(["PORT"], 8080);
const BASE_URL = firstEnv(["BASE_URL", "REACT_APP_BASE_URL"], "https://repeatconnect.com");
const BASE_URL_API = firstEnv(
  ["BASE_URL_API", "REACT_APP_BASE_URL_API"],
  `${BASE_URL}/api/klantenportaal`
);

const CALENDLY_API_KEY = firstEnv(["CALENDLY_API_KEY", "REACT_APP_CALENDLY_API_KEY"]);

const CALENDLY_USER_ID = firstEnv([
  "CALENDLY_USER_ID",
  "REACT_APP_CALENDLY_USER_ID",
]);
const CALENDLY_ORGANIZATION_ID = firstEnv([
  "CALENDLY_ORGANIZATION_ID",
  "REACT_APP_CALENDLY_ORGANIZATION_ID",
]);
const CALENDLY_WEBHOOK_ID = firstEnv(["CALENDLY_WEBHOOK_ID"]);
const CALENDLY_SCHEDULED_EVENT_ID = firstEnv(["CALENDLY_SCHEDULED_EVENT_ID"]);

const BASE_URL_API_CAL = firstEnv(
  ["BASE_URL_API_CAL", "REACT_APP_BASE_URL_API_CAL"],
  "https://api.calendly.com"
);
const BASE_URL_API_CAL_WEBHOOK = firstEnv(
  ["BASE_URL_API_CAL_WEBHOOK", "REACT_APP_BASE_URL_API_CAL_WEBHOOK"],
  `${BASE_URL_API_CAL}/webhook_subscriptions`
);
const BASE_URL_API_CAL_SCHEDULED_EVENTS = firstEnv(
  ["BASE_URL_API_CAL_SCHEDULED_EVENTS", "REACT_APP_BASE_URL_API_CAL_SCHEDULED_EVENTS"],
  `${BASE_URL_API_CAL}/scheduled_events`
);
const BASE_URL_API_CAL_EVENT_TYPES = firstEnv(
  ["BASE_URL_API_CAL_EVENT_TYPES", "REACT_APP_BASE_URL_API_CAL_EVENT_TYPES"],
  `${BASE_URL_API_CAL}/event_types`
);
const BASE_URL_API_CAL_USERS = firstEnv(
  ["BASE_URL_API_CAL_USERS", "REACT_APP_BASE_URL_API_CAL_USERS"],
  `${BASE_URL_API_CAL}/users`
);
const BASE_URL_API_CAL_USERS_ME = firstEnv(
  ["BASE_URL_API_CAL_USERS_ME", "REACT_APP_BASE_URL_API_CAL_USERS_ME"],
  `${BASE_URL_API_CAL}/users/me`
);
const BASE_URL_API_CAL_INVITEES = firstEnv(
  ["BASE_URL_API_CAL_INVITEES", "REACT_APP_BASE_URL_API_CAL_INVITEES"],
  `${BASE_URL_API_CAL}/invitees`
);
const BASE_URL_API_CAL_INVITATIONS = firstEnv(
  ["BASE_URL_API_CAL_INVITATIONS", "REACT_APP_BASE_URL_API_CAL_INVITATIONS"],
  `${BASE_URL_API_CAL}/invitations`
);
const BASE_URL_API_CAL_ORGANIZATIONS = firstEnv(
  ["BASE_URL_API_CAL_ORGANIZATIONS", "REACT_APP_BASE_URL_API_CAL_ORGANIZATIONS"],
  `${BASE_URL_API_CAL}/organizations`
);
const BASE_URL_API_CAL_WEBHOOKS = firstEnv(
  ["BASE_URL_API_CAL_WEBHOOKS", "REACT_APP_BASE_URL_API_CAL_WEBHOOKS"],
  `${BASE_URL_API_CAL}/webhooks`
);
const BASE_URL_API_CAL_WEBHOOK_SUBSCRIPTIONS = firstEnv(
  ["BASE_URL_API_CAL_WEBHOOK_SUBSCRIPTIONS", "REACT_APP_BASE_URL_API_CAL_WEBHOOK_SUBSCRIPTIONS"],
  `${BASE_URL_API_CAL}/webhook_subscriptions`
);

const IMAGE_URL_API = firstEnv(["IMAGE_URL_API", "REACT_APP_IMAGE_URL_API"], BASE_URL);
const DOCUMENTS_URL_API = firstEnv(
  ["DOCUMENTS_URL_API", "REACT_APP_DOCUMENTS_URL_API"],
  BASE_URL
);
const PAGESIZE = envNumber(["PAGESIZE", "REACT_APP_PAGESIZE"], 25);

const ACCESS_TOKEN_SECRET = firstEnv(["ACCESS_TOKEN_SECRET"]);
const REFRESH_TOKEN_SECRET = firstEnv(["REFRESH_TOKEN_SECRET"]);

const TOKEN_EXPIRY = firstEnv(["TOKEN_EXPIRY"], "2h");
const REFRESH_TOKEN_EXPIRY = firstEnv(["REFRESH_TOKEN_EXPIRY"], "7");

const ADMIN_MAIL_FROM = firstEnv(["ADMIN_MAIL_FROM"], "info@repeathealth.com");
const ADMIN_MAIL_SMTP_HOST = firstEnv(["ADMIN_MAIL_SMTP_HOST"], "send.one.com");
const ADMIN_MAIL_SMTP_PORT = envNumber(["ADMIN_MAIL_SMTP_PORT"], 587);
const ADMIN_MAIL_SMTP_SECURE = envBoolean(["ADMIN_MAIL_SMTP_SECURE"], false);
const ADMIN_MAIL_IMAP_HOST = firstEnv(["ADMIN_MAIL_IMAP_HOST"], "imap.one.com");
const ADMIN_MAIL_IMAP_PORT = envNumber(["ADMIN_MAIL_IMAP_PORT"], 993);
const ADMIN_MAIL_IMAP_SECURE = envBoolean(["ADMIN_MAIL_IMAP_SECURE"], true);


const MAKE_SOCKET_CHANNEL = (id, channel) => {
  if (id == null || id === "") return channel;
  return `${channel}_${String(id)}`;
};

const SOCKET_CHANNELS = {
  COMMENTS: firstEnv(["SOCKET_CHANNEL_COMMENTS", "REACT_APP_SOCKET_CHANNEL_COMMENTS"], "RP_COMMENTS"),
  USERS: firstEnv(["SOCKET_CHANNEL_USERS", "REACT_APP_SOCKET_CHANNEL_USERS"], "RP_USERS"),
  PREINTAKE: firstEnv(["SOCKET_CHANNEL_PREINTAKE", "REACT_APP_SOCKET_CHANNEL_PREINTAKE"], "RP_PREINTAKE"),
  EETDAGBOEK: firstEnv(["SOCKET_CHANNEL_EETDAGBOEK", "REACT_APP_SOCKET_CHANNEL_EETDAGBOEK"], "RP_EETDAGBOEK"),
  MAIL: firstEnv(["SOCKET_CHANNEL_MAIL", "REACT_APP_SOCKET_CHANNEL_MAIL"], "RP_MAIL"),
  MAIL_ITEM: firstEnv(["SOCKET_CHANNEL_MAIL_ITEM", "REACT_APP_SOCKET_CHANNEL_MAIL_ITEM"], "RP_MAIL_ITEM"),
  MAIL_TYPING: firstEnv(["SOCKET_CHANNEL_MAIL_TYPING", "REACT_APP_SOCKET_CHANNEL_MAIL_TYPING"], "RP_MAIL_TYPING"),
  AFSPRAKEN: firstEnv(["SOCKET_CHANNEL_AFSPRAKEN", "REACT_APP_SOCKET_CHANNEL_AFSPRAKEN"], "RP_AFSPRAKEN"),
  VRAGENLIJSTEN: firstEnv(["SOCKET_CHANNEL_VRAGENLIJSTEN", "REACT_APP_SOCKET_CHANNEL_VRAGENLIJSTEN"], "RP_VRAGENLIJSTEN"),
  KLACHTENFORMULIER: firstEnv(["SOCKET_CHANNEL_KLACHTENFORMULIER", "REACT_APP_SOCKET_CHANNEL_KLACHTENFORMULIER"], "RP_KLACHTENFORMULIER"),
  DOCUMENTEN: firstEnv(["SOCKET_CHANNEL_DOCUMENTEN", "REACT_APP_SOCKET_CHANNEL_DOCUMENTEN"], "RP_DOCUMENTEN"),
  VOORUITGANG: firstEnv(["SOCKET_CHANNEL_VOORUITGANG", "REACT_APP_SOCKET_CHANNEL_VOORUITGANG"], "RP_VOORUITGANG"),
  CHAT: firstEnv(["SOCKET_CHANNEL_CHAT", "REACT_APP_SOCKET_CHANNEL_CHAT"], "RP_CHAT"),
  SUPPORT: firstEnv(["SOCKET_CHANNEL_SUPPORT", "REACT_APP_SOCKET_CHANNEL_SUPPORT"], "RP_SUPPORT"),
  PAYMENTS: firstEnv(["SOCKET_CHANNEL_PAYMENTS", "REACT_APP_SOCKET_CHANNEL_PAYMENTS"], "RP_PAYMENTS"),
};

module.exports = {
  SOCKET_CHANNELS,
  MAKE_SOCKET_CHANNEL,
  PORT,
  BASE_URL,
  BASE_URL_API,
  IMAGE_URL_API,
  BASE_URL_API_CAL,
  CALENDLY_API_KEY,
  CALENDLY_USER_ID,
  CALENDLY_ORGANIZATION_ID,
  CALENDLY_WEBHOOK_ID,
  CALENDLY_SCHEDULED_EVENT_ID,
  BASE_URL_API_CAL_WEBHOOKS,
  BASE_URL_API_CAL_WEBHOOK_SUBSCRIPTIONS,
  BASE_URL_API_CAL_SCHEDULED_EVENTS,
  BASE_URL_API_CAL_EVENT_TYPES,
  BASE_URL_API_CAL_USERS,
  BASE_URL_API_CAL_USERS_ME,
  BASE_URL_API_CAL_INVITEES,
  BASE_URL_API_CAL_INVITATIONS,
  BASE_URL_API_CAL_ORGANIZATIONS,
  DOCUMENTS_URL_API,
  PAGESIZE,
  ACCESS_TOKEN_SECRET,
  REFRESH_TOKEN_EXPIRY,
  REFRESH_TOKEN_SECRET,
  TOKEN_EXPIRY,
  ADMIN_MAIL_FROM,
  ADMIN_MAIL_SMTP_HOST,
  ADMIN_MAIL_SMTP_PORT,
  ADMIN_MAIL_SMTP_SECURE,
  ADMIN_MAIL_IMAP_HOST,
  ADMIN_MAIL_IMAP_PORT,
  ADMIN_MAIL_IMAP_SECURE,
};
